import { type Ref, watch } from 'vue';
import { useLibraryLimitsFeatureFlag } from '~/composables/myLibraryHelpers';
import useUserDerivedDetails from '~/composables/useUserDerivedDetails';
import setupContentStatusStore from '.';

interface User {
  subscriptionWithLimit: {
    priviledges: {
      libraryLimit?: number,
    },
  },
}

function watchForLibraryLimits() {
  // Define the types for user and isLoggedIn
  const { user, isLoggedIn }: { user: Ref<User | undefined>; isLoggedIn: Ref<boolean> } = useUserDerivedDetails();
  const showLibraryLimits = useLibraryLimitsFeatureFlag();

  function setupLibraryLimits() {
    if (isLoggedIn.value) {
      const subscriptionWithLimit = user.value?.subscriptionWithLimit;

      if (subscriptionWithLimit && showLibraryLimits.value) {
        setupContentStatusStore(subscriptionWithLimit.priviledges.libraryLimit as number);
      }
    }
  }

  watch(
    isLoggedIn,
    setupLibraryLimits,
    { immediate: true },
  );

  watch(
    showLibraryLimits,
    setupLibraryLimits,
    { immediate: true },
  );
}

export default watchForLibraryLimits;
